import { unblockWindow } from "../../functions/Utilities.js";
import { getUrlToCheckBox } from "../links.js";
import {
  GET_ITEM_FETCH_REQUEST,
  GET_ITEM_FETCH_SUCCESS,
  GET_ITEM_FETCH_FAILURE,
  UPDATE_PRICE_INVENTORY,
  SUPPLIER_INFO_SUCCESS,
  ADD_TO_CART_MODAL_CLOSE,
  CHANGE_PRODUCT_ATTRIBUTES,
  CHANGE_TITLE_AND_LONGDESC,
  SHOW_CONTINUE_MODAL,
  UNMOUNT_PRODUCT_PAGE,
  SET_REVIEW_MODAL_STATE,
  REQUEST_MAIN_PRODUCT_SKUS_N_SKUIDS,
  SUCECSS_MAIN_PRODUCT_SKUS_N_SKUIDS,
  FAILURE_MAIN_PRODUCT_SKUS_N_SKUIDS,
  SET_ATTRIBUTES_DETAILS,
  SET_CART_VALIDATION_ERR,
  POPULATE_ACCESSORY_MODAL,
  CLOSE_ACCESSORY_MODAL,
  GET_MODAL_ITEM_FETCH_SUCCESS,
  deliveryOptionsActions,
  addToCartActions,
  SHOW_CONTINUE_MODAL_QUOTE,
  UPDATE_ACCESSORY_INVENTORY,
  confirmActions,
  SET_PRODUCT_SWITCH_IMAGE_FLAG,
  SET_PRODUCT_IMAGECAROUSEL_INITIAL,
  SET_PRODUCT_OUT_OF_STOCK_ERR,
  SET_PERSONALZED_QUESTIONS,
  SET_PERSONALZED_QUESTIONS_PROGRESS,
  SET_USER_INPUTS_PERSONALIZED_QUESTIONS,
  SET_CHEQUE_VALIDATIONS,
  SET_CHEQUE_VALIDATION_ERRORS,
  SET_BIID,
  CONFIRM_LEAVE,
  SAVE_INPUTS,
  SET_LOADING_FOR_REVIEW_PROCESS,
  SET_JUMP_TO_REVIEW_TAB,
  SET_PRODUCT_TYPE
} from "../types.js";

const initialState = {
  itemDetail: {
    code: ""
  },
  priceInventory: {},
  loading: true,
  product: {
    title: "",
    price: { integer: "", decimal: "" },
    image: "",
    currency_sign: "",
    url: "",
    id: ""
  },
  biid: undefined,
  biidReview: undefined,
  displayLoadingForReviewProcess: undefined,
  jumpToReviewTabOnCustomizer: undefined,
  personalizedQuestionsValidationErrors: {},
  personalizedQuestionsValidations: {},
  personalizedQuestions: {},
  skipAndDisableSectionProgress: [],
  personalizedQuestionsProgress: {
    jsonIssue: { occured: false, modalActive: false },
    confirmLeave: false,
    displayQuestions: false,
    displayBundleItemsMessage: false,
    progress: 0,
    currentItemIsBundleItem: false,
    bundleItemsProgress: null,
    bundleItems: null,
    bundleItemParentId: null,
    inputs: {},
    savedInputs: {},
    font: { selectedFont: "", "Imprint Colour": "", "2nd Ink Colour": "" },
    logo: {
      logoMode: "",
      selectedClipart: null,
      uploadedLogo: null,
      tiff: null
    },
    detailIDs: {
      startNumberDetailId: null,
      startNumberPrefixDetailId: null,
      transitNumberDetailId: null,
      institutionNumberDetailId: null,
      accountNumberDetailId: null,
      advertisingSloganDetailId: null,
      companyInformationQuestion: null,
      companyInformationQuestionDetailIds: null
    }
  },
  noproduct: false,
  supplierInfo: [],
  requestingAddToCart: false,
  addToCartSuccess: false,
  addToCartMode: "",
  selectedProductAttributes: {},
  productInitial: {
    title: "",
    longDesc: "",
    properties: []
  },
  reviewsModalOpen: false,
  frequentlyBoughtTogether: [],
  accessories: [],
  alsoLike: [],
  accessoryModal: {
    status: false,
    loading: true,
    title: "",
    imageUrl: "",
    price: "",
    priceInv: {},
    details: { longdesc: "", code: "" }
  },
  deliveryOptions: "",
  productImageSwitch: false,
  productPageImageCarouselInitial: true,
  productType: null
};

const copyInitialState = { ...initialState };

const setPrice = price => {
  return { integer: price.integer, decimal: price.decimal };
};

const handleRedirect = payload => {
  window.removeEventListener("beforeunload", unblockWindow);

  window.location.href = getUrlToCheckBox(payload);
};

const productReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_PRODUCT_TYPE:
      return {
        ...state,
        productType: payload
      };
    case CONFIRM_LEAVE:
      return {
        ...state,
        confirmLeave: payload
      };
    case SET_JUMP_TO_REVIEW_TAB:
      return {
        ...state,
        jumpToReviewTabOnCustomizer: payload
      };
    case SET_BIID:
      return {
        ...state,
        biid: payload.biid,
        biidReview: payload.review,
        displayLoadingForReviewProcess: payload.review
      };
    case SET_LOADING_FOR_REVIEW_PROCESS:
      return {
        ...state,
        displayLoadingForReviewProcess: payload
      };
    case POPULATE_ACCESSORY_MODAL:
      return {
        ...state,
        accessoryModal: {
          ...state.accessoryModal,
          status: true,
          title: payload.title,
          imageUrl: payload.imageUrl,
          price: payload.price
        }
      };
    case SET_PRODUCT_SWITCH_IMAGE_FLAG:
      return {
        ...state,
        productImageSwitch: payload
      };
    case SET_PRODUCT_IMAGECAROUSEL_INITIAL: {
      return {
        ...state,
        productPageImageCarouselInitial: payload
      };
    }
    case CLOSE_ACCESSORY_MODAL:
      return {
        ...state,
        accessoryModal: {
          status: false,
          loading: true,
          title: "",
          imageUrl: "",
          price: "",
          priceInv: {},
          details: { longdesc: "", code: "" }
        }
      };
    case UNMOUNT_PRODUCT_PAGE:
      return {
        ...copyInitialState
      };
    case CHANGE_TITLE_AND_LONGDESC:
      return {
        ...state,
        productInitial: payload,
        frequentlyBoughtTogether: [...payload.frequentlyBoughtTogether],
        accessories: [...payload.accessories],
        alsoLike: [...payload.alsoLike]
      };
    case ADD_TO_CART_MODAL_CLOSE:
      return {
        ...state,
        addToCartSuccess: false
      };
    case SHOW_CONTINUE_MODAL:
      if (payload) {
        handleRedirect(payload);
      } else
        return {
          ...state,
          addToCartSuccess: true
        };
    case SHOW_CONTINUE_MODAL_QUOTE:
      if (payload) {
        handleRedirect(payload);
      } else
        return {
          ...state,
          addToCartSuccess: true
        };

    case addToCartActions.REQUEST_ADD_TO_CART:
      return {
        ...state,
        requestingAddToCart: true
      };
    case confirmActions.CONFIRM_NO: {
      return {
        ...state,
        requestingAddToCart: false
      };
    }
    case addToCartActions.SUCCESS_ADD_TO_CART:
      return {
        ...state,
        addToCartMode: payload,
        requestingAddToCart: false
      };
    case addToCartActions.FAILURE_ADD_TO_CART:
      return {
        ...state,
        requestingAddToCart: false
      };
    case GET_ITEM_FETCH_REQUEST:
      return {
        ...state,
        loading: true,
        noproduct: false,
        addToCartSuccess: false
      };
    case GET_MODAL_ITEM_FETCH_SUCCESS:
      return {
        ...state,
        accessoryModal: {
          ...state.accessoryModal,
          loading: false,
          details: payload.json
        }
      };

    case SET_CHEQUE_VALIDATION_ERRORS:
      return {
        ...state,
        personalizedQuestionsValidationErrors: payload
      };
    case SET_CHEQUE_VALIDATIONS:
      return {
        ...state,
        personalizedQuestionsValidations: {
          ...state.personalizedQuestionsValidations,
          ...payload
        }
      };
    case SET_PERSONALZED_QUESTIONS_PROGRESS:
      if (payload.setSelectedFont) {
        state.personalizedQuestionsProgress.font.selectedFont = payload.value;
        return {
          ...state
        };
      } else {
        return {
          ...state,
          personalizedQuestionsProgress: {
            ...state.personalizedQuestionsProgress,
            ...payload
          }
        };
      }

    case SET_USER_INPUTS_PERSONALIZED_QUESTIONS:
      if (payload.replace) {
        delete state.personalizedQuestionsProgress.inputs[payload.key];
        return { ...state };
      } else {
        return {
          ...state,
          personalizedQuestionsProgress: {
            ...state.personalizedQuestionsProgress,
            inputs: {
              ...state.personalizedQuestionsProgress.inputs,
              ...payload
            }
          }
        };
      }

    case SAVE_INPUTS:
      return {
        ...state,
        personalizedQuestionsProgress: {
          ...state.personalizedQuestionsProgress,
          savedInputs: {
            ...state.personalizedQuestionsProgress.inputs
          }
        }
      };

    case SET_PERSONALZED_QUESTIONS:
      return {
        ...state,
        personalizedQuestions: payload.questions,
        skipAndDisableSectionProgress: payload.skipAndDisableSectionProgress
      };
    case GET_ITEM_FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        itemDetail: {
          ...payload.json,
          mainProductSkus: state.itemDetail.mainProductSkus
            ? [...state.itemDetail.mainProductSkus]
            : payload.json.mainitemid === 0
            ? payload.json.skus
            : undefined,
          mainProductSkuIds: state.itemDetail.mainProductSkuIds
            ? [...state.itemDetail.mainProductSkuIds]
            : payload.json.mainitemid === 0
            ? payload.json.skuids
            : undefined,
          attributeDetails: state.itemDetail.attributeDetails
            ? [...state.itemDetail.attributeDetails]
            : undefined,          
          pdtDiscount: payload.json.discount          
        },
        noproduct: false,
        addToCartSuccess: false
      };

    case GET_ITEM_FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        error: payload,
        noproduct: true,
        addToCartSuccess: false
      };
    case UPDATE_ACCESSORY_INVENTORY:
      return {
        ...state,
        accessoryModal: {
          ...state.accessoryModal,
          priceInv: payload
        }
      };
    case UPDATE_PRICE_INVENTORY:
      return {
        ...state,
        priceInventory: payload
      };
    case SUPPLIER_INFO_SUCCESS:
      return {
        ...state,
        loading: false,
        supplierInfo: [...payload]
      };
    case CHANGE_PRODUCT_ATTRIBUTES:
      return {
        ...state,
        selectedProductAttributes: payload
      };
    case SET_ATTRIBUTES_DETAILS:
      return {
        ...state,
        itemDetail: { ...state.itemDetail, attributeDetails: [...payload] }
      };
    case SET_CART_VALIDATION_ERR:
      return {
        ...state,
        itemDetail: {
          ...state.itemDetail,
          cartValidationErrors: [...payload]
        }
      };
    case SET_PRODUCT_OUT_OF_STOCK_ERR:
      return {
        ...state,
        itemDetail: {
          ...state.itemDetail,
          productOutOfStockError: payload
        }
      };
    case SET_REVIEW_MODAL_STATE:
      return {
        ...state,
        reviewsModalOpen: payload
      };
    case SUCECSS_MAIN_PRODUCT_SKUS_N_SKUIDS:
      return {
        ...state,
        itemDetail: { ...state.itemDetail, ...payload }
      };

    default:
      return state;
  }
};

export default productReducer;
